import { required } from "vuelidate/lib/validators";
const sattalep = {
  data() {
    return {
      sattalepData: {
        Baslik: null,
        Taleptarih: null,
        Sartnameurl: null,
        Birimid: null,
        Kullanicitasinirid:null,
        Kullanicigerceklestirmeid: null,
        Kullaniciharcamaid:null,
        Sartnametip: [],
        Harcamatipid: null,
        Onaydurum: 1,
        Deleted: false,
      },
      FormDataType: {
        Baslik: {
          FieldName: "Adi",
          Field: "input",
          FieldTitle: this.$t("sattalep.AddEdit.Baslik"),
        },
        Taleptarih: {
          FieldName: "Taleptarih",
          Field: "input",
          FieldTitle: this.$t("sattalep.AddEdit.Taleptarih"),
          FieldType: "date",
        },
        Birimid: {
          FieldName: "Birimid",
          Field: "combobox",
          FieldTitle: this.$t("sattalep.AddEdit.Birimid"),
          ComboDataArray: [],
        },
        Kullanicitasinirid: {
          FieldName: "Kullanicitasinirid",
          Field: "combobox",
          FieldTitle: this.$t("sattalep.AddEdit.Kullanicitasinirid"),
          ComboDataArray: [],
        },
        Kullanicigerceklestirmeid: {
          FieldName: "Kullanicigerceklestirmeid",
          Field: "combobox",
          FieldTitle: this.$t("sattalep.AddEdit.Kullanicigerceklestirmeid"),
          ComboDataArray: [],
        },
        Kullaniciharcamaid: {
          FieldName: "Kullaniciharcamaid",
          Field: "combobox",
          FieldTitle: this.$t("sattalep.AddEdit.Kullaniciharcamaid"),
          ComboDataArray: [],
        },
        Harcamatipid: {
          FieldName: "Harcamatipid",
          Field: "combobox",
          FieldTitle: this.$t("sattalep.AddEdit.Harcamatipid"),
          ComboDataArray: [],
        },
        Sartnametip: {
          FieldName: "Sartnametip",
          Field: "combobox",
          FieldTitle: this.$t("sattalep.AddEdit.Sartnametip"),
          ComboDataArray: [],
        },
      },
    };
  },
  validations: {
    FormData: {
      Baslik: { required },
      Taleptarih: { required },
      Birimid: { required },
      Kullanicitasinirid: {  },
      Kullanicigerceklestirmeid: { required },
      Kullaniciharcamaid: {  },
      Harcamatipid: {  },
      Sartnametip: {  },
    },
  },
  created() {
    let Page = {
      PageNumber: "1",
      PageSize: "9999",
    };

    this.ActionsGet({ Service: "OBirim", Page: Page }).then((res) => {
      for (var i = 0; i < res.Data.length; i++) {
        this.FormDataType.Birimid.ComboDataArray.push({
          Id: res.Data[i].Id,
          Value: res.Data[i].BirimAdi,
        });
      }
    });
    this.ActionsGet({ Service: "OPersonel", Page: Page }).then((res) => {
      for (var i = 0; i < res.Data.length; i++) {
        this.FormDataType.Kullanicitasinirid.ComboDataArray.push({
          Id: res.Data[i].Id,
          Value: res.Data[i].Adsoyad,
        });
        this.FormDataType.Kullanicigerceklestirmeid.ComboDataArray.push({
          Id: res.Data[i].Id,
          Value: res.Data[i].Adsoyad,
        });
        this.FormDataType.Kullaniciharcamaid.ComboDataArray.push({
          Id: res.Data[i].Id,
          Value: res.Data[i].Adsoyad,
        });
      }
    });
    this.ActionsSabitGet(1548).then((res) => {
      for (var i = 0; i < res.Data.length; i++) {
        this.FormDataType.Harcamatipid.ComboDataArray.push({
          Id: res.Data[i].Id,
          Value: res.Data[i].Value,
        });
      }
    });
    this.ActionsSabitGet(1555).then((res) => {
      for (var i = 0; i < res.Data.length; i++) {
        this.FormDataType.Sartnametip.ComboDataArray.push({
          id: res.Data[i].Id,
          label: res.Data[i].Value,
        });
      }
    });
  },
};
export default sattalep;
